import { render, staticRenderFns } from "./AssignMasterDrawer.vue?vue&type=template&id=5efbd9f4&scoped=true"
import script from "./AssignMasterDrawer.vue?vue&type=script&lang=js"
export * from "./AssignMasterDrawer.vue?vue&type=script&lang=js"
import style0 from "./AssignMasterDrawer.vue?vue&type=style&index=0&id=5efbd9f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efbd9f4",
  null
  
)

export default component.exports